import React, { useState } from 'react';
import BasicInput from '../Basic/BasicInput';

function Intake({ intake, countIndex, changeFieldsMultiple }) {
    const [stateIntake, setStateIntake] = useState(intake);
    
    const changeIntake = () => {
        intake !== stateIntake && changeFieldsMultiple([
            {
                index: countIndex,
                field: 'intake',
                value: stateIntake,
            },
        ]);
    };
    
    return (
        <BasicInput 
            name='intake'
            value={stateIntake}
            onChange={e => setStateIntake(e.target.value)}
            floatingLabelStyle={{ display: 'none' }}
            underlineStyle={{ display: 'none' }}
            style={{ fontSize: '9px' }}
            type='number'
            onBlur={changeIntake}
        />
    );
}

export default React.memo(Intake);



// WEBPACK FOOTER //
// ./app/components/TcIndex/RowData/Intake.jsx